import { useHandler } from "@/hooks";
import { useRefInputStore } from "@/state/stores";

type AutoResizeTextareaReturn = {
  adjustHeight: () => void;
  resetHeight: () => void;
};

export function useAutoResizeTextarea(): AutoResizeTextareaReturn {
  const textareaRef = useRefInputStore(({ inputRef }) => inputRef);

  const adjustHeight = useHandler(() => {
    const textarea = textareaRef.current;
    if (!textarea) {
      return;
    }

    // Reset height temporarily to get the correct scrollHeight
    textarea.style.height = "auto";

    // Calculate new height (min 1 line, max 10 lines)
    const lineHeight = Number.parseInt(
      getComputedStyle(textarea).lineHeight,
      10,
    );
    const maxHeight = lineHeight * 10;
    const newHeight = Math.min(textarea.scrollHeight, maxHeight);

    textarea.style.height = `${newHeight}px`;
  });

  const resetHeight = useHandler(() => {
    const textarea = textareaRef.current;
    if (!textarea) {
      return;
    }

    // Reset to minimum height (1 line)
    const lineHeight = Number.parseInt(
      getComputedStyle(textarea).lineHeight,
      10,
    );
    textarea.style.height = `${lineHeight}px`;
  });

  return { adjustHeight, resetHeight } as const;
}
